import angular from 'angular';
import 'angular-ui-router';
import 'ng-file-upload/dist/ng-file-upload';
import 'angular-modal-service';
import Filters from '../../filters/filters';
import template from './mraidPlayableCreativesForm.jade';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import FiltersModule from '../../filters/filters';
import {buildCreativeDefinition,copyCreativeDefinition} from './creativesTextBlock';

export class MRaidPlayableCreativesFormController {
  /* @ngInject */
  constructor($scope, $element, $timeout, $window, currentGame, $filter, $stateParams, GamesResource, ModalService, Upload, setProgressBar, notify, $sce) {
    this.$scope = $scope;
    this.$window = $window;
    this.ModalService = ModalService;
    this.GamesResource = GamesResource;
    this.$stateParams = $stateParams;
    this.$sce = $sce;
    this.currentGame = currentGame;
    this.translate = $filter('translate');
    this.translateWith = $filter('translateWith');
    this.Upload = Upload;
    this.setProgressBar = setProgressBar;
    this.notify = notify;
    this.buildCreativeDefinition = buildCreativeDefinition;
    this.copyCreativeDefinition = copyCreativeDefinition;
    this.statusOptions =	[
      {name: 'active', value: true},
      {name: 'inactive', value: false}
    ];

    this.mraidApiFrameworks =	[
      {name: 'MRAID-1', value: 3},
      {name: 'MRAID-2', value: 5},
      {name: 'MRAID-3', value: 6}
    ];

    if(!this.creative.id) {
      this.creative.active = true;
    }

    $scope.$on('scrollToCreative', (event, creativeId) => {
      if (this.creative && String(this.creative.id) === String(creativeId)) {
        $timeout(() => {
          const el = $element[0];
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          el.classList.add('is-highlighted');
          $timeout(() => el.classList.remove('is-highlighted'), 2000);
          if (this.mraidMainDefinition && this.mraidMainAssetUrl) {
            this.openAdMainPreview();
          }
        }, 300);
      }
    });
  }

  removeCreative() {
    if (!this.creative.id) {
      let indexOfCreativeToRemove = _.findIndex(this.variation.creatives, (creative) => {return creative.type == this.creative.type;});
      if (indexOfCreativeToRemove > -1) {
        this.variation.creatives.splice(indexOfCreativeToRemove,1);
      }
    } else {
      this.creative.is_deleted = true;
      return this.GamesResource.one(this.$stateParams.gameId).one('variations', this.creative.variation_id).one('creatives', this.creative.id).customPUT(this.creative)
          .then((creativeRes) => {
            let indexOfCreativeToRemove = _.findIndex(this.variation.creatives, (creative) => {return creative.id == this.creative.id;});
            if (indexOfCreativeToRemove > -1) {
              this.variation.creatives.splice(indexOfCreativeToRemove,1);
            }
          });
    }
  }

  get creatives() {
    return _.chain(this.variation).map('creatives').flatten().value();
  }

  latestCreative() {
    return _.chain(this.creatives).filter('timestamp').sortBy('timestamp').last().value();
  }

  startCustomize(){
    this.creative.definition = this.buildCreativeDefinition(this.creative.size);
    this.copyCreativeDefinition(this.latestCreative(), this.creative);
    this.creative.customize = true;
    this.creative.timestamp = new Date();
  }

  cancelCustomize(){
    this.creative.definition = null;
    this.creative.customize = false;
  }
  handleNewMRaidPlayableFile(mraidPlayableFile){
    this.isLoadingMRaidPlayableFile = true;
    if (mraidPlayableFile){
      this.$scope.$emit('newFileUploaded', mraidPlayableFile, this.creative, 'mraidPlayableFile');
      this.setProgressBar(this, 1, 1).then(() => this.isLoadingMRaidPlayableFile = false);
    }
  }

  get mraidMainAssetUrl() {
    return this.creative.url
  }

  get mraidMainDefinition() {
    return this.creative.definition
  }
  openAdMainPreview(){
    if (!this.mraidMainDefinition || !this.mraidMainAssetUrl) return;
    this.updateUrlWithCreativeId();
    let [width, height] = (this.creative.size || '750x650').split('x').map(v => parseInt(v, '10'));
    let mraidPreviewUrl = this.$sce.trustAsResourceUrl("https://bidder.dsp.youappi.com/creative/preview/" + this.creative.id);
    this.showPreviewModal(mraidPreviewUrl, width, height).then((modal) => modal.closed.then(() => this.removeCreativeIdFromUrl()));
  }

  showPreviewModal(res, width, height){
    return this.ModalService.showModal({
      template: `
        <div class="c-analytics-modal is-open" ng-click="vm.close()">
          <div class="text-center u-mt++">
            <iframe ng-src="{{vm.res}}" style='margin-top: 75px;' width="{{vm.width}}" height="{{vm.height}}" frameborder='0'"/>
            <svg gg-icon='icon-close' style='position: absolute; margin-top: 50px;' width="25" height="25"/>
          </div>
        </div>`,
      controllerAs: 'vm',
      controller: function(close) {
        this.res = res;
        this.width = width;
        this.height = height;
        this.close = close;
      }
    });
  }

  buildDeepLink() {
    const variationId = this.variation && this.variation.id;
    const creativeId = this.creative && this.creative.id;
    if (!variationId || !creativeId) return null;
    const baseUrl = this.$window.location.href.replace(/#\d+(-\d+)?$/, '');
    return baseUrl + '#' + variationId + '-' + creativeId;
  }

  updateUrlWithCreativeId() {
    const deepLink = this.buildDeepLink();
    if (deepLink) {
      this.$window.history.replaceState(null, '', deepLink);
    }
  }

  removeCreativeIdFromUrl() {
    const cleanedUrl = this.$window.location.href.replace(/-\d+$/, '');
    this.$window.history.replaceState(null, '', cleanedUrl);
  }

}

let MRaidPlayableCreativesFormComponent = {
  template: () => { return template },
  controller: MRaidPlayableCreativesFormController,
  controllerAs: 'vm',
  bindings: {
    campaign: '=',
    creative: '=',
    variation: '=',
    disableField: '='
  }
};

export default angular.module('app.components.campaigns.mraidPlayableCreativesForm', [
  ConfigsModule.name,
  ServicesModule.name,
  Filters.name,
  FiltersModule.name,
  'angularModalService'
  ])
  .component('mraidPlayableCreativesForm', MRaidPlayableCreativesFormComponent);



/** WEBPACK FOOTER **
 ** ./src/components/creatives/mraidPlayableCreativesForm.js
 **/